import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
import { Label } from './Label';
interface Service {
  title: string;
  desc: string;
  href?: string;
}
export function Services() {
  const services: Service[] = [{
    title: 'Strategy',
    desc: 'The why before the what. Audience-first thinking that earns its place in the deck.'
  }, {
    title: 'Branding',
    desc: 'Identities that hold up at every size, every surface, every scroll.'
  }, {
    title: 'Social',
    desc: "Content that doesn't just post — it pays off."
  }, {
    title: 'Content',
    desc: 'Stories shot, written, and cut for how people actually watch.'
  }, {
    title: 'Web',
    desc: 'Sites that load fast, look right, and convert.'
  }, {
    title: 'Management',
    desc: 'Full career management and representation — from brand development and content strategy to deal negotiation and partnerships. We manage talent, not just projects.',
    href: '/influencers'
  }];
  return <section className="py-[clamp(70px,10vw,140px)] border-b border-brand-gray300" id="services" data-id="element-217" data-mp="36amzovd1jtw4">
      <Container data-id="element-218" data-mp="2xc1j35r4qoxz">
        <div className="flex justify-between items-end gap-[40px] mb-[clamp(40px,6vw,80px)] flex-wrap" data-id="element-219" data-mp="2xckr9uqz9yyt">
          <Label className="self-start" data-id="element-220" data-mp="32bxnv77nikel">01 · Services</Label>
          <h2 className="text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em] max-w-[18ch]" data-id="element-221" data-mp="3q0gttg38al3i">
            Six disciplines. One team. No handoffs.
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-px border-t border-brand-gray300 bg-brand-gray300 max-[900px]:grid-cols-2 max-[540px]:grid-cols-1" data-id="element-222" data-mp="3g29fz648kj5q">
          {services.map(service => {
          const body = <>
                <h3 className="mb-[16px] text-[clamp(1.4rem,2.2vw,2rem)] font-black tracking-[-0.02em]" data-id="element-223" data-mp="24m2nerifjtkc">
                  {service.title}
                </h3>
                <p className="text-[14px] leading-[1.5]" data-id="element-224" data-mp="1pk2v93rtc9r8">{service.desc}</p>
                {service.href && <span className="mt-[18px] inline-block font-mono text-[11px] uppercase tracking-[0.14em] opacity-70" data-id="element-225" data-mp="1lir5my8xvoj1">
                    See influencer management →
                  </span>}
              </>;
          const cardClass = 'group block h-full bg-brand-white p-[36px_24px] text-left transition-colors duration-200 ease-out hover:bg-brand-black hover:text-brand-white focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-accent';
          return service.href ? <Link key={service.title} to={service.href} className={cardClass} data-id="element-226" data-mp="xurc5qk8tk0r">
                {body}
              </Link> : <div key={service.title} className={`${cardClass} cursor-pointer`} data-id="element-227" data-mp="2s5wd2n3y3ice">
                {body}
              </div>;
        })}
        </div>
      </Container>
    </section>;
}